export const addItem = (payload) => ({
  type: 'ADD_ITEM',
  payload,
});

export const actionReadOnly = (is_readyonly) => ({
  type: 'IS_READONLY',
  is_readyonly,
});
